import React, { useState, useRef, useEffect } from "react";


export default function LetsWork() {

    return (
        <>
            <div className="parent">
                <div className="lWT" >
                    <a href="/"><button  className="left-slide"><img src="back_arrow.svg" /></button></a>
                    <img className="lWTitle" src="Portfolio Fonts10.png"/>
                    <span className="self-ill"></span>
                    <h1 className="lwtFull">Let's Work Together</h1>
                    <ul className="contact">
                        <li><img src="twitter.png"/><a href="https://x.com/_Rukachi_"> Rukachi Ariketa</a></li>
                        <li><img  src="artstation.png"/><a href="https://www.artstation.com/rukachi"> _Rukachi_</a></li>
                        <li><img src="linkedin.png"/><a href="https://www.linkedin.com/in/rukachi-ariketa-68714a337/"> Rukachi Ariketa</a></li>
                    </ul>
                        

                </div>
            </div>
        </>
    );
}